import { jwtDecode, type JwtHeader } from "jwt-decode";

export type OfficeSsoTokenClaims = JwtHeader & {
  name?: string;
  preferred_username?: string;
  oid?: string;
};

export type SsoTokenResult = {
  encodedToken: string;
  claims: OfficeSsoTokenClaims;
};

export const fetchSsoToken = async (options: Office.AuthOptions = { allowSignInPrompt: true }): Promise<SsoTokenResult | undefined> => {
  try {
    const encodedToken = await Office.auth.getAccessToken(options);
    const claims = jwtDecode<OfficeSsoTokenClaims>(encodedToken);
    return { encodedToken, claims };
  } catch (error) {
    console.error("Failed to acquire SSO token:", error);
    return undefined;
  }
};
